<p-breadcrumb
  [model]="[{ label: 'Textos', routerLink: ['/text-contents'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Textos</h5>
      <p>Gerencie os textos do site</p>
    </div>
  </div>
</p-toolbar>

<p-table
  #table
  [value]="textContents()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="slugFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Slug"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="contentFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Conteúdo"
          class="w-full"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Slug</th>
      <th>Conteúdo</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.slug || "-" }}</td>
      <td>{{ getContentPreview(item.description) }}</td>
      <td>
        <div class="w-fit">
          <app-tag-status
            [status]="item.isActive ? 'Active' : 'Inactive'"
            [text]="getStatusDescription(item.isActive)"
          />
        </div>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/text-contents/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
